import {FileValidated } from "@dropzone-ui/react";

// Retorna el total de los MB de los archivos subidos por el usuario 
export const getTotalFilesSize = (files: FileValidated[]) => {
  const totalSize = files.reduce((acc, file) => acc + file.file.size, 0);
  return (totalSize/1024/1024);
}